import { Alert, AlertTitle, Box } from '@mui/material'
import type { IperiaResignature } from '../../types/iperiaStatus'

/**
 * Why the bulletin must be signed again. Without it, a second signature request reads like
 * a bug, and the AM or the parent calls the commercial instead of signing.
 */
const IperiaResignatureNotice = ({ resignature }: { resignature?: IperiaResignature | null }) => {
  if (!resignature) return null
  const changes = resignature.changes.filter((change) => change.label)
  if (!resignature.message && changes.length === 0) return null
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <AlertTitle>Le bulletin d'inscription a été mis à jour</AlertTitle>
      {resignature.message && <Box sx={{ mb: changes.length ? 1 : 0 }}>{resignature.message}</Box>}
      {changes.length > 0 && (
        <>
          Informations corrigées :
          <Box component="ul" sx={{ m: 0, pl: 3 }}>
            {changes.map((change) => (
              <li key={change.label}>
                {change.label}
                {change.value ? ` : ${change.value}` : ''}
              </li>
            ))}
          </Box>
        </>
      )}
      Merci de signer cette nouvelle version.
    </Alert>
  )
}

export default IperiaResignatureNotice
